import { apiInstance } from 'api/utils';

export default {
  getModelPortfolioSelection: ({ id }: { id: number }) =>
    apiInstance.request({
      method: 'GET',
      url: `/model-portfolio-selections/${id}/`
    }),
  getModelPortfolioSelectionAllocations: ({ id }: { id: number }) =>
    apiInstance.request({
      method: 'GET',
      url: `/model-portfolio-selections/${id}/allocations/`
    }),
  getModelPortfolio: ({
    modelPortfolioId
  }: {
    modelPortfolioId: string | number;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cip-model-portfolios/${modelPortfolioId}/`
    }),
  getCipModelPortfolios: (modelPortfolioIds: {
    modelPortfolioId: string | number;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: `/cip-model-portfolios/`,
      data: modelPortfolioIds
    }),
  getLatestDefinition: ({ id }: { id: string | number }) =>
    apiInstance.request({ method: 'GET', url: `/latest-definition/${id}/` }),
  createModelPortfolio: ({
    portfolio,
    modelPortfolioData
  }: {
    portfolio?: string;
    modelPortfolioData: any;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/existing-model-portfolios/`,
      data: modelPortfolioData
    }),
  geteModelPortfolio: ({
    portfolio,
    modelPortfolioId
  }: {
    portfolio?: string;
    modelPortfolioId: number;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/existing-model-portfolios/${modelPortfolioId}/`
    }),
  updateModelPortfolio: ({
    portfolio,
    modelPortfolioData,
    modelPortfolioId
  }: {
    portfolio?: string;
    modelPortfolioData: any;
    modelPortfolioId: number;
  }) =>
    apiInstance.request({
      method: 'PATCH',
      url: `/cases/${portfolio}/existing-model-portfolios/${modelPortfolioId}/`,
      data: modelPortfolioData
    }),
  getModelPortfolioCharge: ({
    modelPortfolioId
  }: {
    modelPortfolioId: string | number;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: `/get_model_portfolio_charge/${modelPortfolioId}`
    }),
  addOrUpdateModelPortfolioCharge: ({
    modelPortfolioId,
    chargeData
  }: {
    modelPortfolioId: string | number;
    chargeData: any;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: `/get_model_portfolio_charge/${modelPortfolioId}`,
      data: chargeData
    })
};
